import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const { t } = useTranslation();

  const scrollToCategories = useCallback(() => {
    const el = document.getElementById('categories-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-labelledby="hero-heading">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20cinematic%20light%20rays%20and%20soft%20bokeh%20effect%2C%20warm%20coral%20and%20amber%20tones%2C%20dark%20rich%20atmosphere%2C%20elegant%20and%20sophisticated%2C%20professional%20cinematic%20photography%20style%2C%20no%20text%20no%20people&width=1920&height=1080&seq=hero-bg-xigua&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 flex flex-col items-center justify-center h-full w-full px-4 md:px-6 text-center">
        <h1 id="hero-heading" className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4 md:mb-6 leading-tight">
          高清在线，<span className="text-primary-400">流畅不缓冲</span>
        </h1>
        <p className="text-sm md:text-lg text-background-200/90 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          西瓜视频提供蜜桃视频、红桃视频、樱桃视频等海量高清影视资源，
          无需下载插件，手机电脑网页直接观看，最新剧集实时更新，免费畅享追剧体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/recommended"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-all duration-300 hover:scale-105 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <button
            onClick={scrollToCategories}
            className="px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-full border border-background-50/30 transition-all duration-300 hover:scale-105 text-sm md:text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-grid-line mr-2"></i>
            浏览分类
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <button
          onClick={scrollToCategories}
          className="flex flex-col items-center gap-1 text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
          aria-label="向下滚动"
        >
          <span className="text-xs">探索更多</span>
          <i className="ri-arrow-down-line text-lg animate-bounce"></i>
        </button>
      </div>
    </section>
  );
}